module.exports = __webpack_public_path__ + "static/img/railway_256.3e617b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/railway_256.png
// module id = YPOa
// module chunks = 0